import { variants } from "./variant"
import { media_with_details } from "@core/gql-mockups/media";

export const cart = `
  {
    discount {
      title
      code
    }
    discount_id
    id

    flag_is_gift

    products {  
      product_id
      bundle_id
      mix_variant_keys
      price_key
      flag_shockproof_packing
      count
      count_history {
        old_count
      }
      first_price
      bundle {
        title
        seo {
          full_url
        }
        count
        price {
            main_price
            offer_price
            has_offer
            price
            discount_percent
            offer_label
            offer_expireAt
            show_discount_timer
          }
        extra_fields {
          media {
            url 
            alt
          }
        }
      }
      product {
        title
        custom_fields
        category{
          title
          seo {
          full_url
          }
        }
        brand {
          title
          media ${media_with_details}
          seo {
          full_url
          }
          custom_fields
        }
        variants ${variants}
        mix_variant {
        custom_fields
        keys
        is_notify
        labels_obj
          title
          details {
            count
            limit_min
            limit_max
            limit_max_reached
          }
          price {
          installment_gateways
            main_price
            offer_price
            has_offer
            price
            discount_percent
            offer_label
            offer_expireAt
            offer_startAt
            show_discount_timer
          }
           sub_prices {
        price_key
        price_key_details
        details {
            product_code
            count
            limit_min
            limit_max
            limit_max_reached
            count_status
        }
        price {
            price
            offer_price
            has_offer
            discount_percent
            offer_expireAt
            offer_expireAt
            show_discount_timer
            main_price
        }
    }
          media ${media_with_details}
        }
        seo {
          url
          full_url
        }
        media ${media_with_details}
      }
    }
    total_prices {
      total_count
      total_price_with_discount
      sum_product_price_without_offer
      # payment_price_without_discount
      packaging_price
      packaging_count
      sum_product_price
      post_price
      payment_price
      gift_score
    }
  }
`;

export const total_prices = `
  {
    total_prices {
      total_count
      total_price_with_discount
      sum_product_price_without_offer
      payment_price_without_discount
      packaging_price
      packaging_count
      sum_product_price
      post_price
      payment_price
      gift_score
    }
  }
`;

export const orders = ` {
    id
    number

    note

    createdAt

    address {
      postal_code
      address
      mobile
    }

    shipping_method {
      title
    }

    payment_gateway {
      title
    }

    internal_track_code

    total_prices {
      total_count
      total_weight
      payment_price
      sum_product_price
      post_price
      total_price_with_discount
      sum_product_price_without_offer
      payment_price_without_discount
      packaging_count
      packaging_price
      post_price_after_delivery
      gift_money_spent
    }
    products {
      price {
        price
        offer_price
        has_offer
        main_price
      }      
      product_id
      mix_variant_keys
      count
      product {
        title
         brand {
         title
         seo {
          full_url 
          }
       }
        media {
          url
          alt
        }
        seo {
          url
          full_url
        }
        mix_variant {
          title
          labels_obj
          details {
            product_code
          }
          media {
            alt
            url
          }
        }
      }
    }
    discount_id
    discount {
      title
    }
    post_track_code
    
    #    shipping_method
    #    payment_gateway
    status
    transactions {
      amount
      paidAt
      track_code
      status
      gateway
      unique_number
    }
    date
  }`

export const order_details = ` {
    id
    number

    payment_gateway {
      title
    }

    shipping_method {
      title
    }

    receive_in_person
    receive_from_deputation {
      title
    }

    total_prices {
      payment_price
    }

    transactions {
      track_code
      createdAt
    }
    
    date
  }`

export const transaction_details = ` {
    id
    amount
    createdAt
    track_code
  }`